import { dataTestIds } from 'pdp/src/constants/dataTestIds/dataTestIds'
import type { CommonProps } from 'pdp/src/types/CommonProps'
import {
	getImageGridInfo,
	getImageGridStyles,
} from 'pdp/src/utils/getImageGridConfig/getImageGridConfig'
import styles from './ImageGrid.module.scss'
import { ImageGridItem } from './ImageGridItem/ImageGridItem'

export const IMAGE_ASPECT_RATIO = 0.715

type ImageGridProps = CommonProps

export function ImageGrid({ look }: Readonly<ImageGridProps>): React.ReactNode {
	const { media } = look
	const gridInfo = getImageGridInfo(media)

	return (
		<ul
			className={styles.imageGrid}
			data-testid={dataTestIds['pdp.gallery.grid']}
		>
			{media.map((mediaItem, index) => {
				const { viewWidth, className } = getImageGridStyles({
					gridInfo,
					index,
					styles,
					media,
				})

				return (
					<ImageGridItem
						key={mediaItem.src}
						mediaItem={mediaItem}
						index={index}
						viewWidth={viewWidth}
						className={className}
					/>
				)
			})}
		</ul>
	)
}
